import { render, staticRenderFns } from "./CoCardMarketItem.vue?vue&type=template&id=09cd48be&scoped=true&"
import script from "./CoCardMarketItem.vue?vue&type=script&lang=ts&"
export * from "./CoCardMarketItem.vue?vue&type=script&lang=ts&"
import style0 from "./CoCardMarketItem.vue?vue&type=style&index=0&id=09cd48be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cd48be",
  null
  
)

export default component.exports